var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.730769C0.447715 0.730769 0 1.17848 0 1.73077C0 2.28305 0.447715 2.73077 1 2.73077V0.730769ZM24 2.73077C24.5523 2.73077 25 2.28305 25 1.73077C25 1.17848 24.5523 0.730769 24 0.730769V2.73077ZM1 9.5C0.447715 9.5 0 9.94772 0 10.5C0 11.0523 0.447715 11.5 1 11.5V9.5ZM12.5 11.5C13.0523 11.5 13.5 11.0523 13.5 10.5C13.5 9.94772 13.0523 9.5 12.5 9.5V11.5ZM1 18.2692C0.447715 18.2692 0 18.7169 0 19.2692C0 19.8215 0.447715 20.2692 1 20.2692V18.2692ZM24 20.2692C24.5523 20.2692 25 19.8215 25 19.2692C25 18.7169 24.5523 18.2692 24 18.2692V20.2692ZM1 2.73077H24V0.730769H1V2.73077ZM1 11.5H12.5V9.5H1V11.5ZM1 20.2692H24V18.2692H1V20.2692Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.3aa38c5e16715afedfa9b1adb8607b7d.svg";
export { ForwardRef as ReactComponent };